import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ExplorelogsService } from '../explore-logs/explorelogs.service';
import { RoutecrumpsService } from '../services/routecrumps.service';
import { AlertsvarService } from './alertsvar.service';
import { AlertsService } from './alerts-custom.service';
import { DashboardBuilderService } from '../designer/dashboard-builder-service/dashboard-builder.service';
import { DashboardService } from '../services/dashboard.service';
import { DesignerService } from '../designer/designer.service';
import { DashboardBuilderVarService } from '../designer/dashboard-builder-service/dashboard-builder-var.service';
import { SharedService } from '../services/shared.service';
import { KeyValue } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss'],
})
export class AlertsComponent implements OnInit, OnDestroy{


  // dbData={
  //   "float": true,
  //   "margin": 5,
  //   "minRow": 10,
  //   "acceptWidgets": true,
  //   "cellHeight": 69.8,
  //   "children": [
  //     {
  //         "selector": "widget-wrapper",
  //         "minW": 2,
  //         "minH": 1,
  //         "h": 2,
  //         "maxH": 2,
  //         "maxW": 5,
  //         "id": 175,
  //         "input": {
  //             "data": {
  //                 "selector": "widget-wrapper",
  //                 "type": "label",
  //                 "chartname": "Label",
  //                 "id": 175,
  //                 "title": "Average Alerts/Day",
  //                 "data_source": 11,
  //                 "technology": "Blended",
  //                 "platform_id": 0,
  //                 "fields": [],
  //                 "icon": "/assets/widgets/label.svg",
  //                 "time_range": [
  //                     -1,
  //                     "day",
  //                     29
  //                 ],
  //                 "minW": 2,
  //                 "maxW": 5,
  //                 "minH": 1,
  //                 "maxH": 2
  //             },
  //             "mode": "builder",
  //             "widgetId": 175,
  //             "widgetdata": {
  //                 "title": "Average Alerts/Day",
  //                 "subtitle": "Past 30 days ( 28 Apr - 27 May )",
  //                 "type": "label",
  //                 "style": {
  //                     "axes": {
  //                         "x-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         },
  //                         "y-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         }
  //                     },
  //                     "legend": {
  //                         "icon": null,
  //                         "type": null,
  //                         "enable": null
  //                     },
  //                     "compact": {
  //                         "mode": "auto",
  //                         "type": "number"
  //                     },
  //                     "table_body": {
  //                         "font-size": null,
  //                         "background-color": null
  //                     },
  //                     "table_header": {
  //                         "enable": null,
  //                         "font-size": null,
  //                         "text-align": null,
  //                         "background-color": null
  //                     },
  //                     "widget_title": "Average Alerts/Day",
  //                     "color_palette": [
  //                         "#ff8b68",
  //                         "#fff9eb",
  //                         "#999999",
  //                         "#b86fd3",
  //                         "#56007a",
  //                         "#6d1694",
  //                         "#8a39ac",
  //                         "#f8ad96",
  //                         "#f55524"
  //                     ]
  //                 },
  //                 "widgetdata": {
  //                     "rows": [
  //                         {
  //                             "metric1": 1148724
  //                         }
  //                     ],
  //                     "headers": [
  //                         {
  //                             "disp": "Alertcount",
  //                             "value": "metric1"
  //                         }
  //                     ]
  //                 }
  //             }
  //         },
  //         "x": 0,
  //         "y": 0
  //     },
  //     {
  //         "selector": "widget-wrapper",
  //         "minW": 3,
  //         "minH": 2,
  //         "h": 8,
  //         "maxH": 12,
  //         "maxW": 12,
  //         "id": 179,
  //         "input": {
  //             "data": {
  //                 "selector": "widget-wrapper",
  //                 "type": "horizontal_bar",
  //                 "chartname": "Horizontal Bar",
  //                 "id": 179,
  //                 "title": "Top 10 Alerts",
  //                 "data_source": 12,
  //                 "technology": "Blended",
  //                 "platform_id": 0,
  //                 "fields": [
  //                     "alert_title"
  //                 ],
  //                 "icon": "/assets/widgets/horizontal_bar.svg",
  //                 "time_range": [
  //                     -1,
  //                     "day",
  //                     29
  //                 ],
  //                 "minW": 3,
  //                 "maxW": 12,
  //                 "minH": 2,
  //                 "maxH": 9
  //             },
  //             "mode": "builder",
  //             "widgetId": 179,
  //             "widgetdata": {
  //                 "title": "Top 10 Alerts",
  //                 "subtitle": "Past 30 days ( 28 Apr - 27 May )",
  //                 "type": "horizontal_bar",
  //                 "style": {
  //                     "axes": {
  //                         "x-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         },
  //                         "y-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         }
  //                     },
  //                     "legend": {
  //                         "icon": null,
  //                         "type": null,
  //                         "enable": null
  //                     },
  //                     "compact": {
  //                         "mode": "auto",
  //                         "type": "number"
  //                     },
  //                     "table_body": {
  //                         "font-size": null,
  //                         "background-color": null
  //                     },
  //                     "table_header": {
  //                         "enable": null,
  //                         "font-size": null,
  //                         "text-align": null,
  //                         "background-color": null
  //                     },
  //                     "widget_title": "Top 10 Alerts",
  //                     "color_palette": [
  //                         "#d0648a",
  //                         "#57a79c",
  //                         "#f58db2",
  //                         "#f2b3c9",
  //                         "#22c3aa",
  //                         "#7bd9a5",
  //                         "#8a39ac",
  //                         "#b56cd1",
  //                         "#56007a"
  //                     ]
  //                 },
  //                 "widgetdata": {
  //                     "rows": [
  //                         {
  //                             "metric1": 265740,
  //                             "dimension1": "Outbound Network Connection to High-Risk Countries"
  //                         },
  //                         {
  //                             "metric1": 2024,
  //                             "dimension1": "TI Match - Inbound"
  //                         },
  //                         {
  //                             "metric1": 44,
  //                             "dimension1": "TI Match - Outbound"
  //                         },
  //                         {
  //                             "metric1": 16,
  //                             "dimension1": "Internal IPs contacts many external IPs in a short window. /Destination IP count threshold exceeded "
  //                         },
  //                         {
  //                             "metric1": 8,
  //                             "dimension1": "test list rule 1"
  //                         }
  //                     ],
  //                     "headers": [
  //                         {
  //                             "disp": "AlertTitle",
  //                             "value": "dimension1"
  //                         },
  //                         {
  //                             "disp": "Count",
  //                             "value": "metric1"
  //                         }
  //                     ]
  //                 }
  //             }
  //         },
  //         "w": 5,
  //         "x": 2,
  //         "y": 0
  //     },
  //     {
  //         "selector": "widget-wrapper",
  //         "minW": 2,
  //         "minH": 2,
  //         "h": 8,
  //         "maxH": 9,
  //         "maxW": 12,
  //         "id": 180,
  //         "input": {
  //             "data": {
  //                 "selector": "widget-wrapper",
  //                 "type": "table",
  //                 "chartname": "Table",
  //                 "id": 180,
  //                 "title": "Top 10 Platform-wise Alerts",
  //                 "data_source": 12,
  //                 "technology": "Blended",
  //                 "platform_id": 0,
  //                 "fields": [
  //                     "platform"
  //                 ],
  //                 "icon": "/assets/widgets/table.svg",
  //                 "time_range": [
  //                     -1,
  //                     "day",
  //                     29
  //                 ],
  //                 "minW": 2,
  //                 "maxW": 12,
  //                 "minH": 2,
  //                 "maxH": 9
  //             },
  //             "mode": "builder",
  //             "widgetId": 180,
  //             "widgetdata": {
  //                 "title": "Top 10 Platform-wise Alerts",
  //                 "subtitle": "Past 30 days ( 28 Apr - 27 May )",
  //                 "type": "table",
  //                 "style": {
  //                     "axes": {
  //                         "x-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         },
  //                         "y-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         }
  //                     },
  //                     "legend": {
  //                         "icon": null,
  //                         "type": null,
  //                         "enable": null
  //                     },
  //                     "compact": {
  //                         "mode": "auto",
  //                         "type": "number"
  //                     },
  //                     "table_body": {
  //                         "font-size": null,
  //                         "background-color": null
  //                     },
  //                     "table_header": {
  //                         "enable": null,
  //                         "font-size": null,
  //                         "text-align": null,
  //                         "background-color": null
  //                     },
  //                     "widget_title": "Top 10 Platform-wise Alerts",
  //                     "color_palette": null
  //                 },
  //                 "widgetdata": {
  //                     "rows": [
  //                         {
  //                             "metric1": 267832,
  //                             "dimension1": "Fortigate Firewall"
  //                         }
  //                     ],
  //                     "headers": [
  //                         {
  //                             "disp": "Platform",
  //                             "value": "dimension1"
  //                         },
  //                         {
  //                             "disp": "Count",
  //                             "value": "metric1"
  //                         }
  //                     ]
  //                 }
  //             }
  //         },
  //         "w": 5,
  //         "x": 7,
  //         "y": 0
  //     },
  //     {
  //         "selector": "widget-wrapper",
  //         "minW": 2,
  //         "minH": 1,
  //         "h": 2,
  //         "maxH": 2,
  //         "maxW": 5,
  //         "id": 176,
  //         "input": {
  //             "data": {
  //                 "selector": "widget-wrapper",
  //                 "type": "label",
  //                 "chartname": "Label",
  //                 "id": 176,
  //                 "title": "Total Alerts Today",
  //                 "data_source": 11,
  //                 "technology": "Blended",
  //                 "platform_id": 0,
  //                 "fields": [],
  //                 "icon": "/assets/widgets/label.svg",
  //                 "time_range": [
  //                     0,
  //                     "day",
  //                     0
  //                 ],
  //                 "minW": 2,
  //                 "maxW": 5,
  //                 "minH": 1,
  //                 "maxH": 2
  //             },
  //             "mode": "builder",
  //             "widgetId": 176,
  //             "widgetdata": {
  //                 "title": "Total Alerts Today",
  //                 "subtitle": "Past 1 days ( 27 May - 27 May )",
  //                 "type": "label",
  //                 "style": {
  //                     "axes": {
  //                         "x-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         },
  //                         "y-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         }
  //                     },
  //                     "legend": {
  //                         "icon": null,
  //                         "type": null,
  //                         "enable": null
  //                     },
  //                     "compact": {
  //                         "mode": "auto",
  //                         "type": "number"
  //                     },
  //                     "table_body": {
  //                         "font-size": null,
  //                         "background-color": null
  //                     },
  //                     "table_header": {
  //                         "enable": null,
  //                         "font-size": null,
  //                         "text-align": null,
  //                         "background-color": null
  //                     },
  //                     "widget_title": "Total Alerts Today",
  //                     "color_palette": null
  //                 },
  //                 "widgetdata": {
  //                     "rows": [
  //                         {
  //                             "metric1": 1148724
  //                         }
  //                     ],
  //                     "headers": [
  //                         {
  //                             "disp": "Alertcount",
  //                             "value": "metric1"
  //                         }
  //                     ]
  //                 }
  //             }
  //         },
  //         "x": 0,
  //         "y": 2
  //     },
  //     {
  //         "selector": "widget-wrapper",
  //         "minW": 2,
  //         "minH": 1,
  //         "h": 2,
  //         "maxH": 2,
  //         "maxW": 5,
  //         "id": 177,
  //         "input": {
  //             "data": {
  //                 "selector": "widget-wrapper",
  //                 "type": "label",
  //                 "chartname": "Label",
  //                 "id": 177,
  //                 "title": "Alerts This Week",
  //                 "data_source": 11,
  //                 "technology": "Blended",
  //                 "platform_id": 0,
  //                 "fields": [],
  //                 "icon": "/assets/widgets/label.svg",
  //                 "time_range": [
  //                     -1,
  //                     "day",
  //                     6
  //                 ],
  //                 "minW": 2,
  //                 "maxW": 5,
  //                 "minH": 1,
  //                 "maxH": 2
  //             },
  //             "mode": "builder",
  //             "widgetId": 177,
  //             "widgetdata": {
  //                 "title": "Alerts This Week",
  //                 "subtitle": "Past 7 days ( 21 May - 27 May )",
  //                 "type": "label",
  //                 "style": {
  //                     "axes": {
  //                         "x-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         },
  //                         "y-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         }
  //                     },
  //                     "legend": {
  //                         "icon": null,
  //                         "type": null,
  //                         "enable": null
  //                     },
  //                     "compact": {
  //                         "mode": "auto",
  //                         "type": "number"
  //                     },
  //                     "table_body": {
  //                         "font-size": null,
  //                         "background-color": null
  //                     },
  //                     "table_header": {
  //                         "enable": null,
  //                         "font-size": null,
  //                         "text-align": null,
  //                         "background-color": null
  //                     },
  //                     "widget_title": "Alerts This Week",
  //                     "color_palette": [
  //                         "#a6d4e7",
  //                         "#e0eff6",
  //                         "#b8c4cc",
  //                         "#5fb3d9",
  //                         "#0081b8",
  //                         "#737373",
  //                         "#454545",
  //                         "#9e57bc",
  //                         "#6c2f8f"
  //                     ]
  //                 },
  //                 "widgetdata": {
  //                     "rows": [
  //                         {
  //                             "metric1": 1148724
  //                         }
  //                     ],
  //                     "headers": [
  //                         {
  //                             "disp": "Alertcount",
  //                             "value": "metric1"
  //                         }
  //                     ]
  //                 }
  //             }
  //         },
  //         "x": 0,
  //         "y": 4
  //     },
  //     {
  //         "selector": "widget-wrapper",
  //         "minW": 2,
  //         "minH": 1,
  //         "h": 2,
  //         "maxH": 2,
  //         "maxW": 5,
  //         "id": 178,
  //         "input": {
  //             "data": {
  //                 "selector": "widget-wrapper",
  //                 "type": "label",
  //                 "chartname": "Label",
  //                 "id": 178,
  //                 "title": "Alerts Till Date",
  //                 "data_source": 11,
  //                 "technology": "Blended",
  //                 "platform_id": 0,
  //                 "fields": [],
  //                 "icon": "/assets/widgets/label.svg",
  //                 "time_range": [
  //                     -1,
  //                     "day",
  //                     29
  //                 ],
  //                 "minW": 2,
  //                 "maxW": 5,
  //                 "minH": 1,
  //                 "maxH": 2
  //             },
  //             "mode": "builder",
  //             "widgetId": 178,
  //             "widgetdata": {
  //                 "title": "Alerts Till Date",
  //                 "subtitle": "Past 30 days ( 27 Apr - 26 May )",
  //                 "type": "label",
  //                 "style": {
  //                     "axes": {
  //                         "x-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         },
  //                         "y-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         }
  //                     },
  //                     "legend": {
  //                         "icon": null,
  //                         "type": null,
  //                         "enable": null
  //                     },
  //                     "compact": {
  //                         "mode": "auto",
  //                         "type": "number"
  //                     },
  //                     "table_body": {
  //                         "font-size": null,
  //                         "background-color": null
  //                     },
  //                     "table_header": {
  //                         "enable": null,
  //                         "font-size": null,
  //                         "text-align": null,
  //                         "background-color": null
  //                     },
  //                     "widget_title": "Alerts Till Date",
  //                     "color_palette": null
  //                 },
  //                 "widgetdata": {
  //                     "rows": [
  //                         {
  //                             "metric1": 561479
  //                         }
  //                     ],
  //                     "headers": [
  //                         {
  //                             "disp": "Sum Alertcount",
  //                             "value": "metric1"
  //                         }
  //                     ]
  //                 }
  //             }
  //         },
  //         "x": 0,
  //         "y": 6
  //     },
  //     {
  //         "selector": "widget-wrapper",
  //         "minW": 3,
  //         "minH": 3,
  //         "h": 4,
  //         "maxH": 5,
  //         "maxW": 12,
  //         "id": 181,
  //         "input": {
  //             "data": {
  //                 "selector": "widget-wrapper",
  //                 "type": "area_chart",
  //                 "chartname": "Area Chart",
  //                 "id": 181,
  //                 "title": "Daily Average Alert Trends",
  //                 "data_source": 11,
  //                 "technology": "Blended",
  //                 "platform_id": 0,
  //                 "fields": [
  //                     "time"
  //                 ],
  //                 "icon": "/assets/widgets/area_chart.svg",
  //                 "time_range": [
  //                     -1,
  //                     "day",
  //                     29
  //                 ],
  //                 "minW": 3,
  //                 "maxW": 12,
  //                 "minH": 3,
  //                 "maxH": 5
  //             },
  //             "mode": "builder",
  //             "widgetId": 181,
  //             "widgetdata": {
  //                 "title": "Daily Average Alert Trends",
  //                 "subtitle": "Past 30 days ( 28 Apr - 27 May )",
  //                 "type": "area_chart",
  //                 "style": {
  //                     "axes": {
  //                         "x-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         },
  //                         "y-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         }
  //                     },
  //                     "legend": {
  //                         "icon": null,
  //                         "type": null,
  //                         "enable": null
  //                     },
  //                     "compact": {
  //                         "mode": "auto",
  //                         "type": "number"
  //                     },
  //                     "table_body": {
  //                         "font-size": null,
  //                         "background-color": null
  //                     },
  //                     "table_header": {
  //                         "enable": null,
  //                         "font-size": null,
  //                         "text-align": null,
  //                         "background-color": null
  //                     },
  //                     "widget_title": "Daily Average Alert Trends",
  //                     "color_palette": [
  //                         "#4b970c",
  //                         "#ff8a5c",
  //                         "#f55524",
  //                         "#a6a6a6",
  //                         "#FFB38F",
  //                         "#7ee02f",
  //                         "#dedede",
  //                         "#68c71a",
  //                         "#454545"
  //                     ]
  //                 },
  //                 "widgetdata": {
  //                     "rows": [
  //                         {
  //                             "dimension1": "21 Jan",
  //                             "metric1": 1148724
  //                         }
  //                     ],
  //                     "headers": [
  //                         {
  //                             "disp": "Time",
  //                             "type": "timestamp",
  //                             "value": "dimension1"
  //                         },
  //                         {
  //                             "disp": "Count",
  //                             "type": "number",
  //                             "value": "metric1"
  //                         }
  //                     ]
  //                 }
  //             }
  //         },
  //         "w": 7,
  //         "x": 0,
  //         "y": 8
  //     },
  //     {
  //         "selector": "widget-wrapper",
  //         "minW": 3,
  //         "minH": 2,
  //         "h": 4,
  //         "maxH": 5,
  //         "maxW": 12,
  //         "id": 182,
  //         "input": {
  //             "data": {
  //                 "selector": "widget-wrapper",
  //                 "type": "donut",
  //                 "chartname": "Donut",
  //                 "id": 182,
  //                 "title": "Severity-wise Alert Distribution",
  //                 "data_source": 12,
  //                 "technology": "Blended",
  //                 "platform_id": 0,
  //                 "fields": [
  //                     "severity"
  //                 ],
  //                 "icon": "/assets/widgets/donut.svg",
  //                 "time_range": [
  //                     -1,
  //                     "day",
  //                     29
  //                 ],
  //                 "minW": 3,
  //                 "maxW": 12,
  //                 "minH": 2,
  //                 "maxH": 5
  //             },
  //             "mode": "builder",
  //             "widgetId": 182,
  //             "widgetdata": {
  //                 "title": "Severity-wise Alert Distribution",
  //                 "subtitle": "Past 30 days ( 28 Apr - 27 May )",
  //                 "type": "donut",
  //                 "style": {
  //                     "axes": {
  //                         "x-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         },
  //                         "y-axis": {
  //                             "name": null,
  //                             "enable": null,
  //                             "position": null,
  //                             "font-size": null
  //                         }
  //                     },
  //                     "legend": {
  //                         "icon": "circle",
  //                         "type": "plain",
  //                         "enable": true
  //                     },
  //                     "compact": {
  //                         "mode": "auto",
  //                         "type": "number"
  //                     },
  //                     "table_body": {
  //                         "font-size": null,
  //                         "background-color": null
  //                     },
  //                     "table_header": {
  //                         "enable": null,
  //                         "font-size": null,
  //                         "text-align": null,
  //                         "background-color": null
  //                     },
  //                     "widget_title": "Severity-wise Alert Distribution",
  //                     "color_palette": [
  //                         "#33b5e5",
  //                         "#7fd0f0",
  //                         "#0092d1",
  //                         "#00567a",
  //                         "#0079ad",
  //                         "#f8c4b4",
  //                         "#f28b6b",
  //                         "#c3e1ef",
  //                         "#f55524"
  //                     ]
  //                 },
  //                 "widgetdata": {
  //                     "rows": [
  //                         {
  //                             "metric1": 265740,
  //                             "dimension1": "medium"
  //                         },
  //                         {
  //                             "metric1": 2048,
  //                             "dimension1": "low"
  //                         },
  //                         {
  //                             "metric1": 44,
  //                             "dimension1": "high"
  //                         }
  //                     ],
  //                     "headers": [
  //                         {
  //                             "disp": "Severity",
  //                             "value": "dimension1"
  //                         },
  //                         {
  //                             "disp": "Count",
  //                             "value": "metric1"
  //                         }
  //                     ]
  //                 }
  //             }
  //         },
  //         "w": 5,
  //         "x": 7,
  //         "y": 8
  //     }
  // ],
  //   "disableDrag": true,
  //   "disableResize": true
  // }
dbData={}
  // dbname="Alert Overview"
dbname=''

dashboardId = 22

  routeBack:Subject<null> = new Subject();
  isProgress:boolean = false;
  $destroy:Subject<boolean> = new Subject();

  dashboardSpinner =false
  dashboardExists=false

  constructor
  (
    private explorelogs:ExplorelogsService,
    // private rcrumpService:RoutecrumpsService,
    public alertvarservice:AlertsvarService,
    private alertservice:AlertsService,
    private dashboardService: DesignerService,
    private dashboardbuildervarservice:DashboardBuilderVarService,
    public sharedService : SharedService,
    public crumpService: RoutecrumpsService,
    private router : Router
  ) { 

   
  }

  ngOnInit(): void {

    // this.getDashboard()

//     this.dashboardSpinner=true
//     this.dashboardService.dashboardGet({"dashboard_id":this.dashboardId})
//     .pipe(takeUntil(this.$destroy))
//     .subscribe((val:any) => {
//       this.dbData = val.grid_options
//       this.dbname = val.dashboard_name

// //console.log(this.dbData)
//       this.dashboardSpinner=false
//       this.dashboardExists =true
//     })
    

    // this.alertservice.getAlertFilter({})
    this.crumpService.route_crumps [1] = {
      disp_str:"Alerts",
      routeTo:"alerts",
      callback:this.routeBack,
      isParent:false
    }
    this.crumpService.route_crumps.length = 2;

    this.routeBack.subscribe(()=>{
      this.back_click();
    })

    // this.alertvarservice.alertactionmanagement.actionManagement.pipe(distinctUntilChanged()).pipe(takeUntil(this.$destroy)).subscribe((progress: boolean) => {
    //   this.isProgress = progress;
    // })
  }

  getDashboard(){
    this.dashboardbuildervarservice.dashboard_preview_mode = "landing";
    this.dashboardSpinner=true
    this.dashboardService.dashboardGet({"dashboard_id":this.dashboardId})
    .pipe(takeUntil(this.$destroy))
    .subscribe((val:any) => {
      this.dbData = val.grid_options
      this.dbname = val.dashboard_name

//console.log(this.dbData)
      this.dashboardSpinner=false
      this.dashboardExists =true
    })
  }

  ngOnDestroy(): void {
    this.$destroy.next(true);
    this.$destroy.unsubscribe()
    this.dashboardExists=false
    this.alertservice.factsheetcomponentDestroyed.next(0);
    this.alertvarservice.payload={
      "timerange": [],
      "platform": "firewall_fortigate",
      "tags": {
          "killchain": [],
          "compliance": [],
          "mitreattack": [],
          "threatgroup": []
      },
      "severity": [],
      "status": [],
      "title": [],
      "data_type": [],
      "observable": [],
      "signature": []
    }
    // this.alertvarservice.chips=this.alertvarservice.defaultChips
  }

  changeTab(index:number){
    this.alertvarservice.alertselectedIndex = index;
    if(index == 0){
      this.getDashboard()
    }
  }

  back_click(){
    this.explorelogs.explorelogIndex = 0;
  }

  sidebarClick(){
    this.sharedService.sidebarState(true)
  }

  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  navIconclick(nav: any) {
    //console.log('navIconclick',nav)
        if (nav.isSelectable && nav.url) {
          this.crumpService.homeIcon.isSelected = false
          this.crumpService.resetMenuList()
          this.sharedService.$selectedDashboardLabel.next(nav)
          nav['isSelected'] = true
          this.router.navigateByUrl(nav.url)
    
          this.sharedService.menu.forEach(key=>{
            key.list.forEach(items=>{
              if(items.value != nav.value){
                items.isSelected = false
              }
            })
          })
        }
      }

 
}